import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-936e9f64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }

import Edit from "@/editor/Edit";
import HeadingBlock from "@/editor/Modules/Heading/HeadingBlock";
import Editor from "@/editor/Editor.vue";
import { reactive } from "vue";
import Module from "@/editor/Module";
import HeadingModule from "@/editor/Modules/Heading/HeadingModule";


export default /*#__PURE__*/_defineComponent({
  __name: 'Editor',
  setup(__props) {

const edit = {
	blocks: [
		{
			type: "heading",
			text: "Hello heading!",
			size: 3
		} as HeadingBlock
	]
} as Edit;

const reactiveEdit = reactive(edit);
const modules: { [key: string]: Module } = {
	heading: HeadingModule
};

const defaultBlock = {
	type: "heading",
	text: "",
	size: 3
} as HeadingBlock;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Editor, {
        "get-edit": () => reactiveEdit,
        modules: modules,
        defaultBlock: _unref(defaultBlock)
      }, null, 8, ["get-edit", "defaultBlock"])
    ]),
    _createElementVNode("pre", null, _toDisplayString(reactiveEdit), 1)
  ], 64))
}
}

})